import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MonthCard = ({ monthNumber, isCompleted, onClick }) => {
    return (
        <StyledCard onClick={() => onClick(monthNumber)}>
            <CardContent>
                <MonthTitle>Month {monthNumber}</MonthTitle>
                {isCompleted && <StarIcon icon={["fas", "star"]} />}
            </CardContent>
        </StyledCard>
    );
};

export default MonthCard;

const StyledCard = styled.div`
    border: 2px solid #372844;
    border-radius: 8px;
    background-color: white;
    padding: 20px;
    margin: 5px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    
    &:hover {
        background-color: #f8f9fa;
        box-shadow: 0 4px 8px rgba(55, 40, 68, 0.2);
        transform: translateY(-2px);
    }
`;

const CardContent = styled.div`
    text-align: center;
    width: 100%;
`;

const MonthTitle = styled.h5`
    margin: 0;
    color: #372844;
    font-weight: bold;
`;

const StarIcon = styled(FontAwesomeIcon)`
    margin-left: 10px;
    color: gold;
    font-size: 1.2em;
`;